import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import ConversionGroup from "../../../../groups/ConversionGroup";

class MetricBookingcountWego extends MetricBase {
    constructor() {
        super({
            field: "metric_booking_count",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.wego.bookingcount.chartName"),
            serieLabel: i18n.t("metrics.wego.bookingcount.serieLabel"),
            tooltip: i18n.t("metrics.wego.bookingcount.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricBookingcountWego;
